export const styles = {
  pageWrapper: {
    display: 'flex',
    height: '100vh',
    backgroundColor: '#ede9fe',
  },

  mainContent: {
    flex: 1,
    overflow: 'auto',
    p: 3,
    display: 'flex',
    flexDirection: 'column',
  },

  card: {
    flex: 1,
    borderRadius: 3,
    border: '1px solid #e5e7eb',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    pb: 3,
  },

  emailRow: {
    px: 3,
    pt: 2,
    pb: 0.5,
  },

  emailText: {
    color: "#6b7280",
    fontSize: "0.82rem",
    display: "flex",
    alignItems: "center",
    gap: "6px"
  },

  filterRow: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 2,
    px: 3,
    py: 1.5,
    borderBottom: '1px solid #f3f4f6',
  },

  filterControl: (minWidth) => ({ minWidth }),

  filterLabel: {
    color: '#6b7280',
    '&.Mui-focused': { color: '#5E22F3' },
  },

  filterSelect: {
    borderRadius: 2,
    '& .MuiOutlinedInput-notchedOutline': { borderColor: '#d1d5db' },
    '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#5E22F3' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': { borderColor: '#5E22F3' },
  },

  loadingBox: {
    display: 'flex',
    justifyContent: 'center',
    py: 8,
  },

  progress: {
    color: '#5E22F3',
  },

  tableContainer: {
    flex: 1,
    overflow: 'auto',
    px: 3,
  },

  tableRow: {
    '&:last-child td': { borderBottom: 0 },
  },

  thFirst: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#374151',
    textAlign: 'left',
    width: 200,
    whiteSpace: 'nowrap',
    py: 1.5,
    px: 2,
    borderBottom: '2px solid #e5e7eb',
    backgroundColor: '#fff',
  },

  thCenter: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#374151',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    py: 1.5,
    px: 0.5,
    width: 80,
    borderBottom: '2px solid #e5e7eb',
    backgroundColor: '#fff',
  },

  thTitleBox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '2px',
  },

  thGroup: {
    fontWeight: 600,
    fontSize: '0.875rem',
    color: '#374151',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    py: 1,
    px: 0.5,
    width: 80,
    borderBottom: 'none',
    backgroundColor: '#fff',
  },

  thSubLabel: {
    fontWeight: 600,
    fontSize: '0.8125rem',
    color: '#374151',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    py: 1,
    px: 0.5,
    width: 80,
    borderBottom: '2px solid #e5e7eb',
    borderTop: '1px solid #ede9fe',
    backgroundColor: '#faf9ff',
  },

  thDivider: {
    borderLeft: '2px solid #e5e7eb',
    borderBottom: '2px solid #e5e7eb',
    padding: 0,
    width: '2px',
    backgroundColor: '#fff',
  },

  tdName: {
    px: 2,
    py: 1,
  },

  tdNameBox: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
  },

  tdNameIcon: {
    color: '#5E22F3',
    fontSize: 20,
  },

  tdNameText: {
    color: '#374151',
    fontWeight: 500,
    fontSize: '0.9375rem',
  },

  tdCheck: {
    py: 0.5,
    px: 0,
    width: 80,
    textAlign: 'center',
  },

  tdDivider: {
    borderLeft: '2px solid #e5e7eb',
    padding: 0,
    width: '2px',
  },

  checkbox: {
    color: '#111827',
    '&.Mui-checked': { color: '#5E22F3' },
    padding: 0.5,
  },

  emptyCell: {
    py: 4,
    color: '#9ca3af',
  },

  actionsRow: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    px: 3,
    py: 2,
    borderTop: '1px solid #f3f4f6',
  },

  alertError: {
    mb: 2,
  },

  thSubText: {
    fontWeight: 400,
    color: '#6b7280',
    fontSize: '0.75rem',
  },
};
